export const MIME_TYPE_IMAGE = 'image/*';
export const MIME_TYPE_PDF = 'application/pdf';
export const MIME_TYPE_DOC = 'application/msword';
export const MIME_TYPE_DOCX = '	application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const MIME_TYPE_PPT = 'application/vnd.ms-powerpoint';
export const MIME_TYPE_PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';

export default {
  MIME_TYPE_IMAGE,
  MIME_TYPE_PDF,
  MIME_TYPE_DOC,
  MIME_TYPE_DOCX,
  MIME_TYPE_PPT,
  MIME_TYPE_PPTX,
}



// WEBPACK FOOTER //
// ./src/defaults/MimeType.js